import { Baby, Cake, GraduationCap, Heart, Flower, Medal, Armchair, Compass, Gift } from "@phosphor-icons/react";
import { GIFT_OCCASIONS } from "@/data/categories";

const ICONS = { Baby, Cake, GraduationCap, Heart, Flower, Medal, Armchair, Compass };
const SHORT = { holiday: "Holiday journal" };

export const OccasionPicker = ({ value, onPick }) => (
  <div data-testid="gift-occasion-picker">
    <p className="mb-2 text-sm font-medium text-[#2D2824]">Choose an occasion <span className="font-normal text-[#8A7F76]">(fills in a message you can edit)</span></p>
    <div className="flex flex-wrap gap-2">
      {GIFT_OCCASIONS.map((o) => {
        const Icon = ICONS[o.icon] || Gift;
        const on = value === o.id;
        return (
          <button key={o.id} type="button" data-testid={`gift-occasion-${o.id}`} aria-pressed={on} onClick={() => onPick(o)}
            className={`flex min-h-[44px] items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium transition-colors ${on
              ? "border-[#E06D53] bg-[#E06D53] text-white"
              : "border-[#EBE4DA] bg-white text-[#2D2824] hover:border-[#E06D53]/60 hover:bg-[#FFF4D6]"}`}>
            <Icon size={18} weight="duotone" /> {SHORT[o.id] || o.label}
          </button>
        );
      })}
    </div>
  </div>
);
